import { Component, inject, Input, OnInit } from '@angular/core';

import { ReviewSelectedChallangesStore } from './review-selected-challanges.store';

@Component({
  selector: 'app-review-selected-challanges',
  imports: [],
  providers: [ReviewSelectedChallangesStore],
  templateUrl: './review-selected-challanges.component.html',
  styleUrl: './review-selected-challanges.component.scss',
})
export class ReviewSelectedChallangesComponent implements OnInit {
  readonly store = inject(ReviewSelectedChallangesStore);
  @Input() diagnosisSessionId: string = '';

  ngOnInit(): void {
    this.store.getSelectedChallenges(this.diagnosisSessionId);
  }
}
